module.exports = __webpack_public_path__ + "static/media/Stripe logo - white.a978cdad.svg";